import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  TimezoneOption,
  loadTimezonePreference,
  saveTimezonePreference,
} from "@/lib/timezone";

interface TimezoneState {
  selectedTimezone: TimezoneOption;
  isInitialized: boolean;
}

const initialState: TimezoneState = {
  selectedTimezone: "local",
  isInitialized: false,
};

const timezoneSlice = createSlice({
  name: "timezone",
  initialState,
  reducers: {
    setTimezone: (state, action: PayloadAction<TimezoneOption>) => {
      state.selectedTimezone = action.payload;
      saveTimezonePreference(action.payload);
    },
    initializeTimezone: (state) => {
      if (!state.isInitialized) {
        state.selectedTimezone = loadTimezonePreference();
        state.isInitialized = true;
      }
    },
  },
});

export const { setTimezone, initializeTimezone } = timezoneSlice.actions;
export default timezoneSlice.reducer;
